import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-offer-success-modal',
  templateUrl: './offer-success-modal.component.html',
  styleUrls: ['./offer-success-modal.component.scss'],
})
export class OfferSuccessModalComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.modalCtrl.dismiss();
    }, 2000);
  }

}
